import React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Toggle } from '../ui/toggle';

const MarqueeToggle = ({ showMarquee, onToggle }) => {
  return (
    <Toggle
      pressed={showMarquee}
      onPressedChange={onToggle}
      size="sm"
      className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground [@media(hover:hover)_and_(pointer:fine)]:hover:shadow-md"
      aria-label={showMarquee ? "Hide Marquee" : "Show Marquee"}
      data-testid="marquee-toggle"
    >
      {showMarquee ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
    </Toggle>
  );
};

export default MarqueeToggle;
